import { React, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Cookies from "universal-cookie";
import {
  getUserAccountDetails,
  getNewDashboardInformation,
} from "../redux/actions";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import theme from "../theme/theme";
import CustomButton from "../components/CustomButton/CustomButton";
import CustomAlertLabel from "../components/CustomAlertLabel/CustomAlertLabel";
import { SET_LOADING } from "../redux/action-types";
import HeaderWithLogo from "../components/HeaderWithLogo";
import { analytics } from "../analytics";

const BodyWrapper = styled.div`
  width: 100%;

  .formContainer {
    background-color: white;
    padding: 30px 30px;
    max-width: 500px;
    margin: auto;
    margin-top: 30px;
  }

  .primaryText {
    font-weight: 700;
    font-size: 25px;
    @media (max-width: 480px) {
      font-weight: 700;
      font-size: 15px;
    }
  }

  .secondaryText {
    font-size: 15px;
    margin-top: 20px;

    @media (max-width: 480px) {
      font-size: 10px;
    }
  }

  .tertiaryText {
    font-size: 12px;
    margin-top: 5px;
    color: gray;

    @media (max-width: 480px) {
      font-size: 8px;
    }
  }

  .inputBoxSection {
    margin-top: 20px;
    width: 15px;
    display: flex;

    @media (max-width: 480px) {
      // display: none;
    }
  }

  .inputBox {
    border: 1px solid ${theme.colors.primaryStrong};
    width: 18px;
    margin-left: 10px;
    font-size: 30px;
    padding: 10px;
    border-radius: 5px;

    @media (max-width: 480px) {
      width: 8px;
      margin-left: 5px;
      font-size: 16px;
      padding: 8px;
    }
  }

  .inputBoxError {
    border: 1px solid red;
  }

  @media (max-width: 480px) {
    .formContainer {
      background-color: white;
      padding: 10px 10px;
      max-width: 250px;
      margin: auto;
      margin-top: 30px;
    }
  }

  .checkBoxContainer {
    width: 100%;
    margin-top: 20px;

    .checkbox {
      cursor: pointer;
    }

    .questionText {
      margin-left: 10px;
    }

    .linkButton {
      text-decoration: underline;
      cursor: pointer;
      color: ${theme.colors.primary};
      font-weight: 800;
    }
  }

  .buttonContainer {
    width: 560px;
    margin: auto;
    margin-top: 15px;
    text-align: right;

    @media (max-width: 480px) {
      width: 265px;
      margin: auto;
      margin-top: 15px;
      text-align: right;
    }
  }
`;

const MultifactorAuthentication = () => {
  const history = useHistory();
  const [one, setOne] = useState("");
  const [two, setTwo] = useState("");
  const [three, setThree] = useState("");
  const [four, setFour] = useState("");
  const [five, setFive] = useState("");
  const [six, setSix] = useState("");
  const cookies = new Cookies();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.user);
  const [customAlertMessage, setCustomAlertMessage] = useState("");
  const [isLoaded, setIsLoaded] = useState(true);
  const [isOtpWrong, setIsOtpWrong] = useState(false);
  const [isRememberChecked, setIsRememberChecked] = useState(false);

  const oneRef = useRef(null);
  const twoRef = useRef(null);
  const threeRef = useRef(null);
  const fourRef = useRef(null);
  const fiveRef = useRef(null);
  const sixRef = useRef(null);
  const checkBoxRef = useRef(null);

  const { loginSuccessResponse, userAccountDetails, newDashboardData } =
    useSelector((state) => state.user);

  useEffect(() => {
    if (userAccountDetails) {
      analytics.track("Signed In", {
        userId: userAccountDetails?.id || "",
      });
      if (!userAccountDetails.firstName) {
        history.push(`/account-details`);
      } else if (!userAccountDetails.isAggreWithTermsAndServices) {
        history.push(`/terms-of-services`);
      } else {
        dispatch(getNewDashboardInformation());
      }
    }
  }, [userAccountDetails, history, dispatch]);

  useEffect(() => {
    if (newDashboardData) {
      if (newDashboardData?.length <= 0) {
        history.push("/goal-picker");
      } else {
        history.push("/strategy-screen");
      }
    }
  }, [history, newDashboardData]);

  useEffect(() => {
    if (loading) {
      setIsLoaded(false);
    }
  }, [loading]);

  const handleCheckBoxClick = () => {
    setIsRememberChecked(!isRememberChecked);
  };

  const handleMFA = async () => {
    dispatch({ type: SET_LOADING, payload: true });
    if (
      (one.length > 0) &
      (two.length > 0) &
      (three.length > 0) &
      (four.length > 0) &
      (five.length > 0) &
      (six.length > 0)
    ) {
      setCustomAlertMessage("");
      try {
        await Auth.currentAuthenticatedUser();
        try {
          if (isRememberChecked) {
            await Auth.rememberDevice();
            const response = await Auth.confirmSignIn(
              loginSuccessResponse,
              `${one}${two}${three}${four}${five}${six}`,
              "SMS_MFA"
            );

            if (response?.signInUserSession?.accessToken?.jwtToken) {
              cookies.set(
                "accessToken",
                response?.signInUserSession?.accessToken?.jwtToken,
                { path: "/" }
              );
              dispatch(getUserAccountDetails());
            }
            setIsOtpWrong(false);
          } else {
            const response = await Auth.confirmSignIn(
              loginSuccessResponse,
              `${one}${two}${three}${four}${five}${six}`,
              "SMS_MFA"
            );

            if (response?.signInUserSession?.accessToken?.jwtToken) {
              cookies.set(
                "accessToken",
                response?.signInUserSession?.accessToken?.jwtToken,
                { path: "/" }
              );
              dispatch(getUserAccountDetails());
            }
            setIsOtpWrong(false);
          }
        } catch (error) {
          console.log("ERROR", error);
          setIsOtpWrong(true);
          setCustomAlertMessage(
            "Verification failed. Incorrect six digit code"
          );
          dispatch({ type: SET_LOADING, payload: false });
        }
      } catch (error) {
        try {
          if (isRememberChecked) {
            const response = await Auth.confirmSignIn(
              loginSuccessResponse,
              `${one}${two}${three}${four}${five}${six}`,
              "SMS_MFA"
            );

            await Auth.rememberDevice();
            if (response?.signInUserSession?.accessToken?.jwtToken) {
              cookies.set(
                "accessToken",
                response?.signInUserSession?.accessToken?.jwtToken,
                { path: "/" }
              );
              dispatch(getUserAccountDetails());
            }
            setIsOtpWrong(false);
          } else {
            const response = await Auth.confirmSignIn(
              loginSuccessResponse,
              `${one}${two}${three}${four}${five}${six}`,
              "SMS_MFA"
            );

            if (response?.signInUserSession?.accessToken?.jwtToken) {
              cookies.set(
                "accessToken",
                response?.signInUserSession?.accessToken?.jwtToken,
                { path: "/" }
              );
              dispatch(getUserAccountDetails());
            }
            setIsOtpWrong(false);
          }
        } catch (error) {
          console.log("ERROR", error);
          setIsOtpWrong(true);
          setCustomAlertMessage(
            "Verification failed. Incorrect six digit code"
          );
          dispatch({ type: SET_LOADING, payload: false });
        }
      }
    } else {
      setCustomAlertMessage("Otp must be of 6 digits");
      dispatch({ type: SET_LOADING, payload: false });
    }
  };

  const handleTextBoxInput = (event) => {
    if (event.target.value >= 0 && event.target.value <= 9) {
      switch (event.target.name) {
        case "1":
          setOne("");
          setOne(event.target.value);
          if (event.target.value) twoRef.current.focus();
          break;
        case "2":
          setTwo(event.target.value);
          if (event.target.value) threeRef.current.focus();
          break;
        case "3":
          setThree(event.target.value);
          if (event.target.value) fourRef.current.focus();
          break;
        case "4":
          setFour(event.target.value);
          if (event.target.value) fiveRef.current.focus();
          break;
        case "5":
          setFive(event.target.value);
          if (event.target.value) sixRef.current.focus();
          break;
        case "6":
          setSix(event.target.value);
          if (event.target.value) checkBoxRef.current.focus();
          break;
      }
    }
  };

  return (
    <>
      {(!isLoaded || loading) && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      <BodyWrapper>
        <HeaderWithLogo />
        <div className="formContainer">
          <div className="primaryText">Two-step verification</div>
          <div className="secondaryText">
            A six digit code has been sent to{" "}
            {loginSuccessResponse?.challengeParam?.CODE_DELIVERY_DESTINATION}
          </div>
          <div className="tertiaryText">
            *verification code will expire after 3 minutes
          </div>
          <div className="inputBoxSection">
            <input
              style={{ marginLeft: "0px" }}
              name="1"
              value={one}
              className={`inputBox ${isOtpWrong && "inputBoxError"}`}
              onChange={handleTextBoxInput}
              ref={oneRef}
            />
            <input
              name="2"
              value={two}
              className={`inputBox ${isOtpWrong && "inputBoxError"}`}
              onChange={handleTextBoxInput}
              ref={twoRef}
            />
            <input
              name="3"
              value={three}
              className={`inputBox ${isOtpWrong && "inputBoxError"}`}
              onChange={handleTextBoxInput}
              ref={threeRef}
            />
            <input
              name="4"
              value={four}
              className={`inputBox ${isOtpWrong && "inputBoxError"}`}
              onChange={handleTextBoxInput}
              ref={fourRef}
            />
            <input
              name="5"
              value={five}
              className={`inputBox ${isOtpWrong && "inputBoxError"}`}
              onChange={handleTextBoxInput}
              ref={fiveRef}
            />
            <input
              name="6"
              value={six}
              className={`inputBox ${isOtpWrong && "inputBoxError"}`}
              onChange={handleTextBoxInput}
              ref={sixRef}
            />
          </div>
          <div className="checkBoxContainer">
            <input
              type="checkbox"
              className="checkBox"
              value="Dont ask me again on this device"
              checked={isRememberChecked}
              onClick={handleCheckBoxClick}
              name="rmemberDevice"
              ref={checkBoxRef}
            ></input>
            <span className="questionText">
              Don't ask me again on this device
            </span>
          </div>
          <div className="checkBoxContainer">
            Code expired?{" "}
            <span
              onClick={() => {
                history.push("/login");
              }}
              className="linkButton"
            >
              Login again
            </span>
          </div>
        </div>

        <div className="buttonContainer">
          <CustomButton text="Continue" onClick={handleMFA} />
          <CustomAlertLabel message={customAlertMessage} />
        </div>
      </BodyWrapper>
    </>
  );
};

export default MultifactorAuthentication;
